import type { LabsGqlPatientFragment } from '@orthly/graphql-operations';
import { LabsGqlPatientSortType } from '@orthly/graphql-schema';
import { atom } from 'jotai';

export type PatientListRawPatient = Pick<
    LabsGqlPatientFragment,
    'id' | 'first_name' | 'last_name' | 'birthday' | 'gender'
>;

export const patientSortTypeAtom = atom(LabsGqlPatientSortType.CreatedAt);
